import { rangeTypes } from '@dataplace.ai/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'
import { AverageVoivodeshipIncomeValue, AverageIncomeWrapper, AverageIncomeText } from './OverviewPurchasingPower.styles'
import CatchmentInfoComponent from '../components/CatchmentInfoComponent'
import { StyledWrapper, TitleWrapper } from '../SharedOverview.styles'
import OverviewGaugeChart from './components/OverviewGaugeChart'
import { NO_OVERVIEW_DATA } from '../constants'
import NoOverviewComponentData from '../components/NoOverviewComponentData'

export type OverviewPurchasingPowerData = {
  catchment: {
    mode: (typeof rangeTypes)[keyof typeof rangeTypes]
    length: number
  }
  avgIncome: number
  avgVoivIncome: number
  incomeVsVoivPct: number
} | {
  catchment: typeof NO_OVERVIEW_DATA
  avgIncome: typeof NO_OVERVIEW_DATA
  avgVoivIncome: typeof NO_OVERVIEW_DATA
  incomeVsVoivPct: typeof NO_OVERVIEW_DATA
}

const TILE_TITLE_KEY = 'placeme.analyse.overview.purchasing_power.tile_name'

export function OverviewPurchasingPower(data: OverviewPurchasingPowerData): JSX.Element {
  const { t } = useTranslation()
  const roundNumber = (number: number) => Math.round(number * 100) / 100

  if (data.catchment === NO_OVERVIEW_DATA) {
    return <NoOverviewComponentData title={TILE_TITLE_KEY} />
  }

  const {
    catchment, avgIncome, avgVoivIncome, incomeVsVoivPct,
  } = data

  return (
    <StyledWrapper $width='fit-content'>
      <TitleWrapper>
        {t(TILE_TITLE_KEY)}
        <CatchmentInfoComponent
          length={catchment.length}
          mode={catchment.mode}
        />
      </TitleWrapper>
      <AverageIncomeWrapper>
        <AverageVoivodeshipIncomeValue>
          <NumberFormat
            displayType='text'
            thousandSeparator=' '
            value={roundNumber(avgIncome)}
          />
          {' '}
          {t('generic.net')}
        </AverageVoivodeshipIncomeValue>
        <AverageIncomeText>{t('placeme.analyse.overview.purchasing_power.average_income_in_range')}</AverageIncomeText>
      </AverageIncomeWrapper>
      <OverviewGaugeChart
        tooltipText={`${roundNumber(avgVoivIncome)} ${t('generic.net')}`}
        unit='%'
        value={incomeVsVoivPct}
      />
      <AverageIncomeText>{t('placeme.analyse.overview.purchasing_power.average_income_in_voivodeship')}</AverageIncomeText>
    </StyledWrapper>
  )
}
